import React__default from 'react';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { i as isRtlEnabled } from '../../LocalModules/storm-ui-utils/dist/esm/isRtlEnabled-DXSQ1gyT-C6zs_USs.js';
import { T as Text } from '../../Text/Text-DvcofqkP.js';
import { I as Icon } from '../../Icon/Icon-AcXbY_t4.js';

const StyledScrollButton = /*#__PURE__*/styled.button.withConfig({
  componentId: "sc-storm-ui-40027066__sc-1gzf61k-0"
})(["display:inline-flex;justify-content:center;align-items:center;flex-shrink:0;opacity:0;cursor:pointer;position:absolute;z-index:1;padding:", ";top:50%;transform:translateY(-50%);border-radius:", ";background-color:", ";box-shadow:", ";border:1px solid ", ";color:", ";transition:transform 0.08s ease-in-out;height:", ";:hover,:focus{color:", ";background-color:", ";}:hover,:focus-visible{opacity:0.95;}:focus-visible{", "}:active{background-color:", ";color:", ";transform:translateY(-46%);opacity:1;box-shadow:", ";}", ""], ({
  theme
}) => `${theme.spacing.medium.default} ${theme.spacing.xsmall.default}`, ({
  theme
}) => theme.border.radius.medium, ({
  theme
}) => theme.summaryCardRow.scrollButton.backgroundColor.default, ({
  theme
}) => theme.elevation.shadow.overlay, ({
  theme
}) => theme.elevation.borderColor.medium, ({
  theme
}) => theme.text.color.tertiary, ({
  theme
}) => theme.summaryCardRow.scrollButton.height, ({
  theme
}) => theme.text.color.secondary, ({
  theme
}) => theme.summaryCardRow.scrollButton.backgroundColor.hover, focusOutline, ({
  theme
}) => theme.summaryCardRow.scrollButton.backgroundColor.active, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.elevation.shadow.overlay, ({
  $direction,
  theme
}) => css(["/*! @noflip */ ", ":", ";"], $direction, theme.summaryCardRow.scrollButton.offsetInline));
StyledScrollButton.displayName = 'StyledScrollButton';
const StyledIconWrapper = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40027066__sc-1gzf61k-1"
})(["display:flex;justify-content:center;align-items:stretch;> svg{width:24px;height:24px;}"]);
StyledIconWrapper.displayName = 'StyledIconWrapper';
const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1gzf61k-2"
})(["display:flex;align-items:stretch;"]);
StyledIcon.displayName = 'StyledIcon';
const ScrollButton = ({
  direction,
  onClick
}) => {
  const {
    formatMessage
  } = useIntl();
  const isRtl = isRtlEnabled();
  const label = !isRtl && direction === 'left' || isRtl && direction === 'right' ? formatMessage({
    id: 'previous_scroll_button_label'
  }) : formatMessage({
    id: 'next_scroll_button_label'
  });
  return /*#__PURE__*/React__default.createElement(StyledScrollButton, {
    $direction: direction,
    onClick: onClick,
    "data-testid": `scroll-button-${direction}`
  }, /*#__PURE__*/React__default.createElement(StyledIconWrapper, null, /*#__PURE__*/React__default.createElement(StyledIcon, {
    type: `angle-${direction}`,
    size: "2x"
  })), /*#__PURE__*/React__default.createElement(Text, {
    srOnly: true
  }, label));
};

export { ScrollButton as S, StyledScrollButton as a };
//# sourceMappingURL=ScrollButton-BD97mvrr.js.map
